import { createSlice } from '@reduxjs/toolkit'
import axios from "axios"
import ApiClient from "../ApiClient"

export const userSlice = createSlice({
    name:"user",
    initialState:{       
        user:null,
        token: localStorage.getItem('authToken') || null,
        refreshToken: localStorage.getItem('refreshToken') || null
    },
    reducers:{
        setUser: (state,action) =>{
            state.user = action.payload;
        },
        setToken: (state, action) => {
            state.token = action.payload.token;
            if (action.payload.refreshToken) {
                state.refreshToken = action.payload.refreshToken;
                localStorage.setItem('refreshToken', action.payload.refreshToken);
            }
            localStorage.setItem('authToken', action.payload.token);
        },
        logout: (state) =>{
            // Call backend logout asynchronously (fire and forget)
            const rt = localStorage.getItem('refreshToken');
            if (rt) {
                axios.post(`${process.env.REACT_APP_BASE_URL}/auth/logout`, { refreshToken: rt }).catch(() => {});
            }
            state.user = null;
            state.token = null;
            state.refreshToken = null;
            localStorage.removeItem('authToken');
            localStorage.removeItem('refreshToken');
        }
           
    }
});

export const fetchUserAction = () => async dispatch => {
    try{
        const {data} = await ApiClient.get(`${process.env.REACT_APP_BASE_URL}/user`)
        dispatch(userSlice.actions.setUser(data[0]))
    }
    catch(error){
        dispatch(userSlice.actions.setUser(null))
    }
}

export const {setUser, setToken, logout} = userSlice.actions;
export const selectUser = (state) => state.user.user;
export const selectAuthToken = (state) => state.user.token;
export default userSlice.reducer;